export const PROJECT_STATUS_LIST = ['archive', 'active', 'complete'];
export const TASK_STATUS_LIST = ['not started', 'in progress', 'completed', 'blocked', 'reopened'];
export const DEFAULT_PROJECT_STATUS = 'active';
export const PROJECT_EDITOR_ROLE = ['Project Manager', 'Project Owner', 'Team Leader'];
export const ROLE_LEVEL = {
  // Project Owner and Project Manager share the top level so both have full
  // control over every member (and every other role) within a project.
  'Project Owner': 1,
  'Project Manager': 1,
  Stakeholder: 2,
  'Team Leader': 4,
};
export const ROLE_CAN_REMOVE_PROJECT = ['Project Owner', 'Project Manager'];
export const GUEST = 'Stakeholder';
export const TASK_TYPE_LIST = ['Task', 'Issue', 'CR'];
export const ROLE_CAN_UPDATE_TASK_CLASSIFICATION = ['Project Owner', 'Project Manager', 'Team Leader' , "QA"];
export const ROLE_CAN_EDIT_TASK_DETAILS_DATE = ROLE_CAN_UPDATE_TASK_CLASSIFICATION;
export const TASK_STATUS_BY_PROFILE = ['Overdue', 'Pending', 'NotStarted', 'Completed', 'Reopened'];

export const STAKEHOLDER_OVERVIEW_VISIBILITY = {
  clientId: false,
  status: true,
  initialEstimatedHrs: false,
  totalHrs: false,
  startDate: true,
  endDate: true,
  actualStartDate: false,
  actualEndDate: false,
  projectUATDate: true,
  projectLiveDate: true,
  health: true,
  risk: true,
  allowOverSpent: true,
  allowManualTask: true,
  projectMembers: false,
  taskClassification: true,
};

// A fixed palette keeps labels legible on a white card and consistent across projects,
// which a free colour picker would not.
export const PROJECT_LABEL_COLORS = [
  '#E53935',
  '#FB8C00',
  '#FDD835',
  '#43A047',
  '#00ACC1',
  '#1E88E5',
  '#8E24AA',
  '#6D4C41',
];
